<div class='context-menu' cdkMenu>
  @for (item of visibleMenuItems$ | async; track item) {
    <dash-gis-map-context-menu-item
      class='context-menu-item-host'
      [commandName]='item.commandName'
      [label]='item.label'
      [icon]='item.icon'
    [attributes]='item.attributes'></dash-gis-map-context-menu-item>
  }
</div>
